






































import { Component, Mixins, Prop, Inject, Watch } from 'vue-property-decorator';
import IntalentTest from '@/components/intalent/test';
import { LoaderMixin } from '@/pages/profile/mixins';
import Block from '../block';
import { SimpleCard } from '@/pages/profile/blocks';
import { Warning } from '@/pages/profile/components';
import { smartService } from '@/services';
import { ACTIONS } from '@/store/user';
import devConfig from '@/config/http/api.dev';
import { BLOCKS } from './const';
import { ISmart, AxiosInstance, Config, Blocks, TestResult } from './types';
import { Partial } from 'lodash';

@Component({
  components: {
    Block,
    Warning,
    IntalentTest,
  },
})
export default class Smart extends Mixins(LoaderMixin) implements ISmart {
  @Inject()
  readonly $api!: AxiosInstance;

  @Inject()
  readonly $config!: Config;

  @Prop({ type: String, default: '' })
  readonly id!: string;

  @Prop({ type: String, default: '' })
  readonly municipalityId!: string;

  @Prop({ type: String, default: '' })
  readonly age!: string;

  @Prop({ type: String, default: '' })
  readonly name!: string;

  @Prop({ type: Object, default: () => {} })
  readonly initTestResult!: TestResult;

  public blocks: Blocks = BLOCKS;
  public testResult: TestResult = this.initTestResult;
  public process: boolean = false;

  get iframeSrc(): string {
    const { $config, $route, $router, id } = this;
    const fullPath = $router.resolve({
      path: $route.path,
      hash: `child-id-${id}`,
    }).href;
    let { mainURL } =
      process.env.NODE_ENV === 'development' ? devConfig : $config;
    const last = mainURL.length - 1;
    if (mainURL[last] === '/') {
      mainURL = mainURL.substring(0, last);
    }

    if (mainURL === '') {
      mainURL = window.location.origin;
    }

    const apiPath = '/api/intalent/results/create';
    const cr = encodeURIComponent(`${mainURL}${apiPath}`);
    const rs = encodeURIComponent(`${mainURL}${fullPath}`);

    const params: { [key: string]: string | number | boolean } = {
      new: true,
      layout: 'headless',
      sendmethod: 'ajax',
      post_url: cr,
      finish: 'sn',
      'x-site_user_kid_id': this.$store.state.user.profile?.intalent_id,
    };
    // const base =
    //   process.env.NODE_ENV === 'development'
    //     ? `//atlas.dev.intalent.pro/`
    //     : `//widget.intalent.pro/`;
    const base = `//intalant.ru/spa-widget/`;
    const qs = Object.keys(params)
      .map((key: string) => [key, params[key]].join('='))
      .join('&');

    return [base, qs].join('?');
  }

  @Watch('id', { immediate: true })
  onChangeChild(id: string): void {
    this.reset();
    if (id) this.getTestResults(false);
  }

  @Watch('process')
  onProcessTest(process: boolean): void {
    this.reset();
    if (this.id && !process) this.getTestResults(true);
  }

  async getTestResults(testPassed: boolean = false): Promise<void> {
    (this as any).setStatus('loading');
    try {
      if (testPassed) {
        await this.$store.dispatch(`user/${ACTIONS.GET_CHILDREN}`);
      }
      this.testResult = this.initTestResult;

      const { age, municipalityId, blocks, testResult } = this;
      const data = {
        age,
        municipalityId,
        blocks,
        testResult,
      };
      this.blocks = smartService(this.$api).setDataToBlocks(data);
      (this as any).setStatus('success');
    } catch (error) {
      (this as any).setStatus('error');
    }
  }

  reset(): void {
    this.testResult = {} as any;
  }

  onCompleted(): void {
    this.process = false;
    this.$emit('completed');
  }

  onClick(): void {
    this.process = !this.process;
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/views/cabinet/components/smart/Smart.vue